import styled, { keyframes } from "styled-components";

const colors = {
  paper: {
    bg: "#516EF4",
    border: "#2543C3",
  },
  scissors: {
    bg: "#ECA81E",
    border: "#C76C14",
  },
  rock: {
    bg: "#DE3A5A",
    border: "#980E31",
  },
};

const Option = ({
  type = "default",
  play,
  showShadow,
  handleTookOption = () => {},
}) => {
  console.log(showShadow);
  return (
    <OptionStyled
      onClick={() => handleTookOption(type)}
      type={type}
      color={colors[type]}
      play={play}
      showShadow={showShadow}
    >
      <OptionInset type={type} play={play}>
        {type !== "default" && (
          <img src={`./images/icon-${type}.svg`} alt={type} />
        )}
      </OptionInset>
    </OptionStyled>
  );
};

export default Option;

const shadow = keyframes`
  to {
    box-shadow: 0 0 0 40px rgba(255,255,255,.04), 0 0 0 80px rgba(255,255,255,.04), 0 0 0 120px rgba(255,255,255,.02);
    transform:  scale(1.1);
  }
`;

const OptionStyled = styled.div`
  cursor: pointer;
  animation: 1s ${({ showShadow }) => (showShadow ? shadow : "")} forwards;
  border: ${({ type, color }) =>
    type === "default" ? "none" : `1rem solid ${color?.bg}`};
  border-radius: 50%;
  box-shadow: ${({ type, color, showShadow }) =>
    type === "default"
      ? "none"
      : `${
          showShadow
            ? "0 0 0 0px rgba(255,255,255,.04), 0 0 0 0px rgba(255,255,255,.04), 0 0 0 0px rgba(255,255,255,.02)"
            : `0 5px 0 ${color?.border};`
        }`};
  transition: transform 0.5s ease;
  padding: ${({ type }) => (type === "default" ? "1rem" : "0")};
  height: 125px;
  width: 125px;
  :active {
    transform: scale(0.9);
  }
  @media screen and (min-width: 1024px) {
    border: ${({ type, color }) =>
      type === "default" ? "none" : `1.5rem solid ${color?.bg}`};
    width: ${({ play }) => (play ? "250px" : "180px")};
    height: ${({ play }) => (play ? "250px" : "180px")};
  }
`;

const OptionInset = styled.div`
  background: ${({ type }) =>
    type === "default" ? "rgba(0, 0, 0, .2)" : "white"};
  border-radius: 50%;
  box-shadow: ${({ type }) =>
    type === "default" ? "none" : "0 -5px 0 #babfd4"};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  @media screen and (min-width: 1024px) {
    img {
      width: ${({ play }) => play && "50%"};
    }
  }
`;
